/* unplugin-vue-components disabled */import script from "./XTable.vue?vue&type=script&setup=true&lang=tsx"
export * from "./XTable.vue?vue&type=script&setup=true&lang=tsx"

import "./XTable.vue?vue&type=style&index=0&id=57ce1cb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ce1cb0"]])

export default __exports__